import { useEffect } from 'react';

type PageMetaProps = {
  title: string;
  description: string;
  path: string;
  index?: boolean;
};

export default function PageMeta({ title, description, path, index = true }: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string) => {
      let element = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.name = name;
        document.head.appendChild(element);
      }
      element.content = content;
    };

    setMeta('description', description);
    setMeta('robots', index ? 'index, follow' : 'noindex, follow');

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `https://animeopeningquiz.com${path}`;
  }, [description, index, path, title]);

  return null;
}
